// import React from 'react'
// import styled from 'styled-components'
// import { StyledWrapper } from './styles';

// const ContentSec3 = ({props}:any) => {
//     console.log(props);
//   return (
//           <StyledWrapper>
//             {
//               props?.description &&
//               <div className='w-[98%] xl:w-[95%] py-10 lg:py-20 px-4 text-[20px] leading-10  contentsection1 bg-white 2xl:w-[76%] mx-auto'
//                 dangerouslySetInnerHTML={{ __html: props?.description }} />
//             }
//           </StyledWrapper>
//   )
// }

// export default ContentSec3


"use client";
import { useMemo } from "react";
import { LuExternalLink } from "react-icons/lu";
import { FaTrophy, FaLightbulb, FaChartLine, FaUsers, FaBriefcase,  FaHeart } from "react-icons/fa6";
import Button from '@/components/CommonComponent/button';
import { FaFileAlt, FaFolderOpen, FaQuestionCircle } from "react-icons/fa";

interface ContentItem {
  text: string;
  icon: string;
  linkText?: string;
  url?: string;
}

interface ContentData {
  drives: ContentItem[];
  experience: ContentItem[];
}

const staticData: ContentData = {
  drives: [
    {
      text: "Pushing boundaries to stay ahead of industry trends.",
      icon: "innovation"
    },
    {
      text: "Every campaign is backed by analytics and real insights.",
      icon: "data"
    },
    {
      text: "A workplace where talent thrives and ideas come to life.",
      icon: "collaboration"
    }
  ],
  experience: [
    {
      text: "A journey that inspires many marketers to achieve their dreams.",
      linkText: "Know about us",
      url: "https://www.w3era.com/about-us/",
      icon: "about"
    },
    {
      text: "Get an inside look at the team and work environment.",
      linkText: "Life at W3era",
      url: "https://www.w3era.com/life-at-w3era/",
      icon: "life"
    },
    {
      text: "Celebrating achievements in Search marketing.",
      linkText: "Our Awards & Recognitions",
      url: "https://www.w3era.com/about-us/awards/",
      icon: "awards"
    },
    {
      text: "Be part of a company that values growth and innovation.",
      linkText: "Careers",
      url: "https://www.w3era.com/career/",
      icon: "career"
    },
    {
      text: "A showcase of successful projects across industries.",
      linkText: "Our Portfolio",
      url: "https://www.w3era.com/portfolio/",
      icon: "portfolio"
    },
    {
      text: "The impact of our G.R.O.W.T.H. strategy on thousands of clients.",
      linkText: "Our Case Studies",
      url: "https://www.w3era.com/case-studies/",
      icon: "case"
    }
  ]
};

const ContentSection = () => {

  const content = useMemo(() => staticData, []);

  const getIcon = (type: string) => {
    switch(type) {
      case 'innovation': return <FaLightbulb className="text-" />;
      case 'data': return <FaChartLine className="text-blue-500" />;
      case 'collaboration': return <FaUsers className="text-" />;
      case 'life': return <FaHeart className="text-purple-500" />; 
      case 'awards': return <FaTrophy className="text-blue-600" />;
      case 'career': return <FaBriefcase className="text-black" />;
      case 'portfolio': return <FaFolderOpen className="text-blue-600" />;
      case 'case': return <FaFileAlt className="text-blue-600" />;
      default: return <FaQuestionCircle className="text-blue-500" />;
    }
  };

  return (
    <div className="w-full max-w-[76rem] mx-auto px-4 py-12">
      <div className="mb-16">
        <h4 className="!text-[22px] md:!text-[24px] lg:!text-[30px] 2xl:!text-[38px] !font-[900] mb-8 text-center text-gray-800">What Drives Us</h4>
        
        <div className="md:hidden space-y-4">
          {content.drives.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md flex items-start gap-4 transition-shadow hover:shadow-lg"
            >
              <div className="text-2xl mt-1">
                {getIcon(item.icon)}
              </div>
              <div>
              <p className="!text-[16px]  sm:!text-[16px] md:!text-[18px]  lg:!text-[20px]  xl:!text-[20px] font-semibold mb-3 text-[#1090D0]">
                {item.icon === 'innovation' ? 'Innovation & Creativity' : 
                 item.icon === 'data' ? 'Data-Driven Strategies' : 'Collaboration & Growth'}
              </p>
                <p className="text-gray-800">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-6">
          {content.drives.map((item, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all flex flex-col items-center text-center"
            >
              <div className="text-4xl mb-4">
                {getIcon(item.icon)}
              </div>
              <p className="!text-[14px]  sm:!text-[16px] md:!text-[18px]  lg:!text-[20px]  xl:!text-[20px] font-bold mb-3 text-[#1090D0]">
                {item.icon === 'innovation' ? 'Innovation & Creativity' : 
                 item.icon === 'data' ? 'Data-Driven Strategies' : 'Collaboration & Growth'}
              </p>
              <p className="text-gray-700">{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-16">
        <h3 className="!text-[22px] md:!text-[24px] lg:!text-[30px] 2xl:!text-[38px] !font-[900] mb-8 text-center text-gray-800">Explore More About the W3era Experience</h3>
        
        <div className="md:hidden space-y-4">
          {content.experience.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md transition-shadow hover:shadow-lg"
            >
              <div className="flex items-start gap-4">
                <div className="text-2xl mt-1">
                  {getIcon(item.icon)}
                </div>
                <div>
                <span className="sm:!text-[17px] md:!text-[18px]  lg:!text-[20px]  xl:!text-[20px] !font-semibold !mb-2 text-gray-800">
                    {item.icon === 'life' ? 'Life at W3era' : 
                     item.icon === 'awards' ? 'Our Awards' : 
                     item.icon === 'career' ? 'Careers' : 
                     item.icon === 'portfolio' ? 'Our Portfolio' : 
                     item.icon === 'case' ? 'Case Studies' : 'About Us'}
                  </span>
                  <p className="text-gray-800 mt-2 !mb-2">{item.text}</p>
                  <a 
                    href={item.url} 
                    className="text-[#1090D0] font-medium flex items-center gap-1 hover:underline"
                  >
                    {item.linkText} <LuExternalLink size={14} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-2 gap-6">
          {content.experience.map((item, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all"
            >
              <div className="flex items-start gap-6">
                <div className="text-3xl mt-1">
                  {getIcon(item.icon)}
                </div>
                <div>
                  <span className="!text-[14px]  sm:!text-[16px] md:!text-[18px]  lg:!text-[20px]  xl:!text-[20px] !font-semibold !mb-2 text-gray-800">
                    {item.icon === 'life' ? 'Life at W3era' : 
                     item.icon === 'awards' ? 'Our Awards' : 
                     item.icon === 'career' ? 'Careers' : 
                     item.icon === 'portfolio' ? 'Our Portfolio' : 
                     item.icon === 'case' ? 'Case Studies' : 'About Us'}
                  </span>
                  <p className="text-gray-600 mt-2 mb-4">{item.text}</p>
                  <a 
                    href={item.url} 
                    className="text-[#1090D0] font-medium flex items-center gap-2 hover:underline"
                  >
                    {item.linkText} <LuExternalLink size={14} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      
      <div className="mt-16 text-center">
        <h3 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800">
          Want to work with the best in the industry?
        </h3>
        <p>
        <a
          href="https://www.w3era.com/career/"
          className="inline-block"
        >
           <Button content="Join the W3era Team" />
        </a>
        </p>
      </div>
    </div>
  );
};

export default ContentSection;